import Vue from 'vue'
import Player from './index.vue'

Player.newInstance = properties => {
    const props = properties || {}

    const instance = new Vue({
        data: props,
        render (h) {
            return h(Player, {
                props
            })
        }
    })

    const component = instance.$mount()
    document.body.appendChild(component.$el)

    return instance.$children[0]
}

function getPlayer () {
    player = player || Player.newInstance()
    return player
}

let player = getPlayer()

export default {
    setUrl (data) {
        player.setUrl(data)
    },
    play () {
        player.play()
    },
    stop () {
        player.stop()
    },
    pause () {
        player.pause()
    },
    show () {
        player.show()
    },
    close () {
        player.close()
    }
}
